import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ModalComponent } from './pages/modal/modal.component';
import { LoginComponent } from './pages/login/login.component';
import { AppendComponent } from './pages/append/append.component';
import { StudyresultComponent } from './pages/studyresult/studyresult.component';
const routes: Routes = [
  {
    path: "home/:id", component: HomeComponent
  },
  {
    path: "login", component: LoginComponent
  },
  {
    path: "admin", component: AdminComponent
  },
  { path: "**", component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
